import { useSyncExternalStore } from 'react';
import { getInstallState, isInstallAvailable, subscribeInstallState } from '@/lib/pwa';

export function usePwaInstall() {
  const state = useSyncExternalStore(subscribeInstallState, getInstallState, getInstallState);
  return { ...state, isAvailable: isInstallAvailable(state) };
}
